import { App as CapacitorApp } from '@capacitor/app';
import { Network } from '@capacitor/network';
import { isNativeApp } from './platform';

const subscribers = new Set();
let started = false;
let lastConnected = typeof navigator !== 'undefined' ? navigator.onLine : true;

function notify(connected) {
    const next = Boolean(connected);
    if (next === lastConnected) {
        return;
    }
    lastConnected = next;
    subscribers.forEach((fn) => fn(lastConnected));
}

async function refreshNativeStatus() {
    try {
        const status = await Network.getStatus();
        notify(status.connected);
    } catch {
        notify(navigator.onLine);
    }
}

function bindWindowEvents() {
    const handler = () => notify(navigator.onLine);
    window.addEventListener('online', handler);
    window.addEventListener('offline', handler);
    notify(navigator.onLine);
}

function start() {
    if (started) {
        return;
    }
    started = true;

    if (!isNativeApp()) {
        bindWindowEvents();
        return;
    }

    // Android-WebView: online/offline-Events bei Flugmodus oft tot.
    // @capacitor/network spricht den ConnectivityManager an.
    refreshNativeStatus();
    Network.addListener('networkStatusChange', (status) => {
        notify(status.connected);
    }).catch(() => {
        bindWindowEvents();
    });
    CapacitorApp.addListener('resume', () => {
        refreshNativeStatus();
    }).catch(() => {
        // App-Plugin fehlt
    });
}

/** Aktuellen Netzstatus und spätere Änderungen. Rückgabe: Unsubscribe. */
export function subscribeNetworkStatus(onChange) {
    start();
    subscribers.add(onChange);
    onChange(lastConnected);
    return () => {
        subscribers.delete(onChange);
    };
}
